<template>
    <div
        class="rp-messenger-conversation"
        @click="$emit('click')"
    >
        <Inline>
            <div class="rp-messager-conv2">
                <div class="rp-img-container">
                    <template v-if="isUnAssigned">
                        <div class="rp-team-assignee">
                            <ImageContainer
                                v-for="(eachAssignee,index) in assignesListForTeamAvatar"
                                :key="index"
                                :imgSrc="eachAssignee.imageURL || ''"
                                :height="getAvatarSize"
                                :width="getAvatarSize"
                                :overRideForDesktop="assignesListForTeamAvatar.length <= 1 ? true : false"
                                :style="getStylesForAvatarAsPerIndex(index)"
                                :initial="eachAssignee.firstName[0] + eachAssignee.lastName[0]"/>
                        </div>
                    </template>
                    <template v-else>
                        <ImageContainer :imgSrc="assigneeImageURL" height="40" width="40" :initial='assigneeInitial'/>
                        <!-- <div v-if="isAgentOnline" class="rp-helpdesk-conversation-list-item-online-status-in-agents-info list-item"></div> -->
                    </template>
                </div>
                <div class="rp-messager-conv-preview">
                    <div class="rp-messager-conv">
                        <div class="rp-messager-operator-name"> {{ assigneeName }} </div>
                        <div class="rp-messenger-conversation-date">
                            <el-tooltip
                                popper-class="rp-tooltip-style"
                                effect="dark"
                                :content="parsedTime"
                                placement="top">
                                <timeago v-if="conversation.lastMessageTime || conversation.updatedAt" :datetime="conversation.lastMessageTime || conversation.updatedAt" :auto-update="60" :converterOptions = "timeDistanceConverterOptions" ></timeago>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="last-text-message-wrapper">
                        <div
                            v-html="text"
                            class="rp-messenger-conversation-last-text"
                            :class="hasNewMessages"
                            >
                        </div>
                        <span v-if="conversation.userUnReadMessagesCount" :title="getNewMessagesMessage" class="new-messages-indicator">
                            
                        </span>
                    </div>
                    
                </div>
            </div>
        </Inline>
    </div>
</template>

<script>
import {
    DateTime
} from 'luxon'
import { mapActions, mapGetters } from 'vuex';
import ImageContainer from './ImageContainer'
import striptags from 'striptags';
const {
    truncate
} = require('../constants')

export default {
    components: {
        ImageContainer
    },
    props: {
        conversation: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            timeDistanceConverterOptions: {
                addSuffix: true,
                shortWordDistance: true,
            }
        }
    },
    computed: {

		...mapGetters({
            agentList: 'agentList',
            allAssignee: 'allAssignee',
            activeAgentList: 'activeAgentList',
            getMembersOfATeam: "getMembersOfATeam",
        }),

        assignesListForTeamAvatar() {
            let teamMembers = []
            let teamToRespond = (this.$root.configuration.style ? this.$root.configuration.style.teamToRespond : 'all') || 'all';
			const agentList = this.getMembersOfATeam(teamToRespond)
			Object.keys(agentList).map(key => {
				const agent = agentList[key];
				if(agent.firstName && agent.lastName && agent.isChatAccess !== false) {
					teamMembers.push(agent)
				}
			})
			//prioritize the users who has images by sorting the agent list
			teamMembers.sort((a,b) => { if(a.imageURL) return -1; return 1 } )
			//teamMembers.sort((a,b) => { if(this.isAgentOnline(a)) return -1; return 1 } )
			return (teamMembers || []).slice(0, 3)
        },
        
        text() {
            const { lastMessageText } = this.conversation;
            let value = this.lastMessageSenderName ? `${this.lastMessageSenderName}: `: '';
            const truncatedText = truncate(striptags(lastMessageText), {
                length: 40
            })
            return value+truncatedText;
        },
        lastMessageSenderName() {
            const {
                lastMessageSenderType,
                lastMessageSenderId,
            } = this.conversation;
            if(lastMessageSenderType === 'operator'){
                if(lastMessageSenderId === 'operator'){
                    return 'Bot'
                }
                const { allAssignee } = this
                const agentData = allAssignee.find(a => a.id === lastMessageSenderId)
                if(agentData && agentData.name){
                    return agentData.name;
                }
                return 'Agent';

            }
            return '';
        },
        parsedTime() {
            return DateTime.fromMillis(this.conversation.updatedAt).setLocale(this.$root.defaultLanguage).toFormat('EEEE, LLLL dd, yyyy hh:mm a')
        },

        assigneeName() {
            const { assignee } = this.conversation
            const { allAssignee } = this
            let as = []
            as = allAssignee.filter(a => a.id === assignee)
            if(as.length > 0 )
                return as[0].name || 'Agent'
            if(this.isUnAssigned)
                return this.$root.configuration.brandData.brandName || 'Agents'
        },
        isUnAssigned() {
            return !this.conversation.assignee || this.conversation.assignee === "unassigned"
        },
        assigneeImageURL() {

            const { assignee } = this.conversation
            const { allAssignee } = this
            let as = []
            as = allAssignee.filter(a => a.id === assignee)
            if(as.length > 0 )
                return as[0].imageURL || ''
            else
                return '' 

        },

        assigneeInitial() {
            const { assignee } = this.conversation
            const { allAssignee } = this
            let as = []
            as = allAssignee.filter(a => a.id === assignee)
            if(as.length > 0 )
                return (as[0].name[0] || '') + (as[0].name[1] || '')
            else
                return 'op'
        },
        getNewMessagesMessage() {
            return `${this.conversation.userUnReadMessagesCount} new messages`
        },
        hasNewMessages() {
            return this.conversation.userUnReadMessagesCount > 0 ? 'new-message-highlight': '';
        },
        isAgentOnline() {
            const { assignee } = this.conversation
			return this.activeAgentList.findIndex((agent)=> agent.operatorId === assignee) >= 0;
        },
        getAvatarSize() {
            return this.assignesListForTeamAvatar.length >=3 ? "25" : this.assignesListForTeamAvatar.length == 2 ? "30": "40"
        }
    },
    methods: {
        getStylesForAvatarAsPerIndex(index) {
            if(this.assignesListForTeamAvatar.length >=3){
                if(index === 0){
                    return {
                        position: "absolute",
                        top: "0px",
                        left: "6px",
                    }
                }
                else if(index === 1){
                    return {
                        position: "absolute",
                        top: "15px",
                        left: "0px",
                    }
                } else if(index === 2){
                    return {
                        position: "absolute",
                        top: "15px",
                        left: "15px",
                    }
                }
            }
            else if(this.assignesListForTeamAvatar.length === 2){
                if(index === 0){
                    return {
                        position: "absolute",
                        top: "0px",
                        left: "0px",
                    }
                }
                else if(index === 1){
                    return {
                        position: "absolute",
                        top: "0px",
                        left: "15px",
                    }
                }
            }
            else if(this.assignesListForTeamAvatar.length === 1){
                return {
                    position: "absolute"
                } 
            }
        }
    },
}
</script>

<style lang="scss">
.rp-messenger-conversation {
    padding: 16px 0px;
    cursor: pointer;
    transition: background-color .3s;
    border-bottom: 1px solid #eeeeee;

    .icon {
        margin-left: auto;
    }
    
}
.rp-messager-operator-name {
    font-size: 12px;
    
    width:100%;
    padding-bottom: 5px;
    font-weight: 400;
}
.rp-messager-operator-name, .rp-messenger-conversation-date{
    @include for-size(desktop-up){
        font-size: 15px !important;
    }
}


.rp-messenger-conversation-last-text {
    font-size: 13px;
    @include for-size(desktop-up){
        font-size: 16px !important;
        width: 650px;
        max-width: 100%;
    }
    color:#000;
    font-weight: $fontWeight;
    word-break: break-word;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 225px;
    p{
        margin: 0;
    }
}

.rp-messenger-conversation-date {
    font-size: 12px;
    width: fill-available;
    display: flex;
    flex-direction: row-reverse;
    font-weight: 400;
}
.rp-messager-conv {
    display: flex;
    align-items: baseline;
    font-size: 12px;
    font-weight: 500;
    color:#666666;
}
.rp-messager-conv2{
    display:flex;
    flex-direction:row;
    align-items: center;
    //margin-right:15px; 
    width:100%;
    position: relative;
    justify-content: space-between;
    .rp-img-container{
        //margin-right: 15px;
        position: relative;
        .rp-team-assignee {
            position: relative;
            height: 40px;
            width: 35px;
            margin-right: 20px;
        }
        .list-item {
            right: 12px;
	    }
    }
    .rp-messager-conv-preview {
        flex-grow: 1;
    }
}
.last-text-message-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1.28;
    .new-messages-indicator {
        height: 8px;
        width: 8px;
        background: red;
        border-radius: 50%;
    }
    .new-message-highlight {
        font-weight: 500;
    }
}


</style>
